import { indexOf, removeItemFromArray, some } from 'shared/utils/array'
import _ from 'lodash'

export const mergeArray = (collection, newInteractions) => {
  if(collection.length === 0) {
    return newInteractions
  }

  const INDEX_KEY = 'interactionId'

  const merged = _.merge(_.keyBy(collection, INDEX_KEY), _.keyBy(newInteractions, INDEX_KEY))

  return Object.values(merged)
}

export const addInteraction = (collection, interaction) => {
  if(collection.length === 0) {
    return [ interaction ]
  }

  const index = indexOf(collection, i => i.interactionId === interaction.interactionId)

  if(index > -1) {
    const firstHalf = collection.slice(0, index)
    const secondHalf = collection.slice(index + 1, collection.length)

    return [...firstHalf, interaction, ...secondHalf]
  } else {
    return [ interaction, ...collection ]
  }
}


export const removeInteraction = (collection, interactionId) => {
  if(collection.length === 0) {
    return collection
  }

  const index = indexOf(collection, i => i.interactionId === interactionId)

  if(index > -1) {
    const newCollection = removeItemFromArray(collection, index)

    return newCollection
  } else {
    return collection
  }
}

export const isInteractionMatchedAssignee = (interaction, userId) => {
  if(
    !interaction ||
    !userId ||
    !Array.isArray(interaction.assignees)
  ) {
    return false
  }

  const matched = some(interaction.assignees, assignee => {
    if(
      !assignee.actor ||
      !Array.isArray(assignee.actor.handles) ||
      assignee.actor.handles.length <= 0
    ) return false

    const assignedUserId = assignee.actor.handles[0].userId

    return userId === assignedUserId && assignee.completedAt === null
  })

  return matched
}
